/**
 * ViewGameBlock — карточка игры для mobile/tablet layout.
 * Desktop использует GameCoverTile; этот компонент — legacy mobile-вид (список с описанием).
 *
 * Prop `game` — объект из GAMES_CATALOG (id, name, description, image_path, link, ...).
 */

import { useNavigate } from "react-router-dom";
import {
  color_black_ultra_light,
  color_grey_ultra_light,
  color_white,
} from "../../../constants/colors";
import { isDesktop } from "../../../utilities/getDeviceType";
import { useWindowDimensions } from "../../../utils";
import { MIN_WIDTH_FOR_MENU } from "../../NavBar";
import { OnestBoldMed, OnestNormalDefault } from "../../styled/TextComponents";
import { GAMES_MOBILE_CARD_ROW_BREAKPOINT } from "./gamesConstants";
import { getGameTilePreviewUrl } from "./gamesUtils";
import { useI18n } from "../../../i18n/I18nProvider";

const ViewGameBlock = ({ game }) => {
  const { t } = useI18n();
  const { width: screenWidth } = useWindowDimensions();
  const navigate = useNavigate();

  if (!game) return null;

  return (
    <div
      onClick={() => {
        if (game.link) navigate(game.link);
      }}
      style={{
        width:
          screenWidth >= 1400
            ? (screenWidth - 300 - 12) / 2 - 50
            : screenWidth >= MIN_WIDTH_FOR_MENU && isDesktop()
              ? (screenWidth - 314 - 8 - 48) / 2
              : screenWidth > 1070
                ? (screenWidth - 50 - 12) / 2 - 50
                : screenWidth > 430
                  ? screenWidth - 50 - 48
                  : screenWidth - 50 - 48,
        height: screenWidth > GAMES_MOBILE_CARD_ROW_BREAKPOINT ? 200 - 48 : "auto",
        borderRadius: 20,
        display: "flex",
        flexDirection: screenWidth > GAMES_MOBILE_CARD_ROW_BREAKPOINT ? "row" : "column",
        justifyContent: "flex-start",
        padding: 24,
        gap: 16,
        backgroundColor: color_white,
        alignItems: "center",
        cursor: "pointer",
      }}
    >
      <img
        style={{
          width: screenWidth > GAMES_MOBILE_CARD_ROW_BREAKPOINT ? 200 : screenWidth - 40 - 48,
          height: screenWidth > GAMES_MOBILE_CARD_ROW_BREAKPOINT ? 152 : "auto",
          borderRadius: 10,
          objectFit: "cover",
          backgroundColor: color_grey_ultra_light,
          transition: "transform 0.3s ease",
        }}
        src={getGameTilePreviewUrl(game)}
        alt={t(game.name)}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.5)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      />

      <div
        style={{
          width: "100%",
          height: screenWidth > GAMES_MOBILE_CARD_ROW_BREAKPOINT ? "100%" : "auto",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        <OnestBoldMed>{t(game.name)}</OnestBoldMed>
        <OnestNormalDefault style={{ color: color_black_ultra_light }}>
          {t(game.description)}
        </OnestNormalDefault>
      </div>
    </div>
  );
};

export default ViewGameBlock;
